import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const VOID = new Observable<void>((observer) => {
  observer.next();
  observer.complete();
});

export const switchMapToVoid = switchMap(() => VOID);
